// extracted by mini-css-extract-plugin
export default {"banner":"ParentRegister_banner__NsmhU","title":"ParentRegister_title__FpHh3","formContainer":"ParentRegister_formContainer__gb7l3"};